import { dynamicSort } from '@/shared/utils/dynamicSort';
import angular from 'angular';

angular.module('cloudX').directive('cxRelationTaxExemptionReasonSelect', function() {
  return {
    restrict: 'E',
    template: `
      <a href=""
         editable-text="selected"
         e-uib-typeahead="txt as txt for txt in options | filter:($viewValue||'')"
         e-typeahead-select-on-exact="true"
         e-typeahead-select-on-blur="false"
         e-typeahead-focus-first="false"
         e-typeahead-min-length="0"
         e-typeahead-on-select="$parent.$form.$submit()"
         e-autocomplete="off"
         e-select-on-focus
         onbeforesave="save(\$data)"
         onaftersave="commitValue()"
          e-size="255"
         blur="submit"
         edit-disabled="disabled">
        <span ng-show="selected" >{{selected}}</span>
        <i class="glyphicon glyphicon-pencil"
           ng-hide="selected"></i>
      </a>`,
    scope: {
      value: '=data',
      onSave: '&',
      disabled: '=?',
      language: '=',
    },
    controller: [
      '$http',
      'appUrls',
      '$scope',
      'flySvc',
      'dialogsSvc',
      'checkSecurity',
      'dataCache',
      function($http, appUrls, $scope, flySvc, dialogsSvc, checkSecurity, dataCache) {
        $scope.selected = null;

        const tenantConfiguration = dataCache.getArray('tenantConfiguration');

        const taxExemptionReasonsPerLanguage = [
          {
            languageCode: 'nl',
            text: 'BTW export',
          },
          {
            languageCode: 'nl',
            text: 'BTW te voldoen door de medecontractant',
          },
          {
            languageCode: 'nl',
            text: 'Vrij van BTW',
          },
          {
            languageCode: 'nl',
            text: 'BTW verlegd intracommunautaire dienst, art 21§2 W.BTW',
          },
          {
            languageCode: 'nl',
            text: 'BTW verlegd intracommunautaire goederen, art 39 bis W.BTW',
          },
          {
            languageCode: 'en',
            text: 'VAT export',
          },
          {
            languageCode: 'en',
            text: 'VAT to be paid by the contracting party',
          },
          {
            languageCode: 'en',
            text: 'Exempt from VAT',
          },
          {
            languageCode: 'en',
            text: 'Exempt from VAT based on art. 21§2 VAT Code (IC-delivery)',
          },
          {
            languageCode: 'en',
            text: 'Exempt from VAT based on art. 39 bis VAT Code (IC-delivery)',
          },
          {
            languageCode: 'fr',
            text: 'Exportation exonérée de TVA',
          },
          {
            languageCode: 'fr',
            text: "Autoliquidation de la TVA conformément à l’art. 20 de l'AR n° 1",
          },
          {
            languageCode: 'fr',
            text: 'Exonéré de TVA',
          },
          {
            languageCode: 'fr',
            text: 'Autoliquidation de la TVA : Art. 21 § 2 du Code belge de la TVA',
          },
          {
            languageCode: 'fr',
            text: 'Autoliquidation Art 39 bis - livraison intracommunautaire',
          },
        ];

        const onInit = () => {
          $scope.options =
            tenantConfiguration == 1
              ? taxExemptionReasonsPerLanguage
                  .filter(x => x.languageCode === $scope.language)
                  .map(x => x.text)
              : [];
          $scope.options.sort();
          $scope.selected = $scope.value;
        };
        onInit();

        $scope.save = function(newValue) {
          $scope.selected = newValue;
          return $scope.onSave({ newValue: newValue });
        };

        $scope.commitValue = function() {
          $scope.value = $scope.selected;
        };

        $scope.$watch('value', () => {
          if ($scope.options) $scope.selected = $scope.value;
        });
      },
    ],
  };
});
